<script setup lang="ts">
import { useAppConfiguration } from '~/stores/appConfiguration'

const { $auth0, $groundcover } = useNuxtApp()
const router = useRouter()

const appConfig = useAppConfiguration()
const { isAuthenticated, logout } = $auth0()

const onSignOut = async () => {
  try {
    if (isAuthenticated.value)
      await logout({
        logoutParams: {
          returnTo: `${location.origin}/auth/login`,
        },
      })
  } catch (error) {
    $groundcover?.captureException(error as Error)
  }

  $groundcover?.updateConfig({ user: null })
  router.push('/auth/login')
}
</script>

<template>
  <div class="min-h-screen">
    <AppToolbar class="sticky top-0">
      <div
        v-if="isAuthenticated && !appConfig.maintenance"
        class="flex h-full items-center"
      >
        <NuxtLink to="/" class="btn btn-outlined h-8">Dashboard</NuxtLink>
      </div>
      <template #user-menu>
        <AppUserMenu v-if="isAuthenticated">
          <ul class="flex flex-col p-2">
            <li>
              <button class="user-menu-link" @click="onSignOut()">
                Log out
              </button>
            </li>
          </ul>
        </AppUserMenu>
        <NuxtLink v-else to="/auth/login" class="btn btn-filled h-8">
          Sign in
        </NuxtLink>
      </template>
    </AppToolbar>
    <slot />
  </div>
</template>

<style scoped>
.user-menu-link {
  @apply inline-flex w-full rounded-lg px-4 py-2 text-left text-sm font-light hover:bg-neutral-100 hover:text-neutral-800;
}
</style>
